<!--
 * www.cloudscope.cn
 * Copyright (c) 2019. All Rights Reserved.
-->
<!--
 * @Author: liuchang
 * @Description: 添加菜单页面
 -->
<template>
    <!-- 添加菜单 Dialog: Begin -->
    <el-dialog
        :title="addTitle"
        :visible.sync="dialogVisible"
        custom-class="mod-dialog"
        append-to-body
        @close="close"
        width="500px"
        id="MenuAdd"
    >
        <div class="main-contain">
            <el-form ref="menu" :model="menu" class="mod-dialog-form" label-width="80px" :rules="rules">
                <el-form-item label="名称" prop="name">
                    <el-input v-model="menu.name" placeholder="输入名称"></el-input>
                </el-form-item>
                <el-form-item label="图标" prop="icon">
                    <el-radio-group v-model="menu.icon" class="menu-icon">
                        <el-radio :label="require('../../assets/images/caiwuguanli.png')">
                            <i>
                                <img
                                    class="menu-icon"
                                    src="../../assets/images/caiwuguanli.png"
                                    style="background:#333"
                                />
                            </i>
                        </el-radio>
                        <el-radio :label="require('../../assets/images/xiangmu.png')">
                            <i>
                                <img
                                    class="menu-icon"
                                    src="../../assets/images/xiangmu.png"
                                    style="background:#333"
                                />
                            </i>
                        </el-radio>
                        <el-radio :label="require('../../assets/images/xitongguanli.png')">
                            <i>
                                <img
                                    class="menu-icon"
                                    src="../../assets/images/xitongguanli.png"
                                    style="background:#333"
                                />
                            </i>
                        </el-radio>
                        <el-radio :label="require('../../assets/images/quanxian.png')">
                            <i>
                                <img
                                    class="menu-icon"
                                    src="../../assets/images/quanxian.png"
                                    style="background:#333"
                                />
                            </i>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="子菜单">
                    <el-radio-group v-model="exist">
                        <el-radio label="have">有</el-radio>
                        <el-radio label="not">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="链接" prop="url">
                    <el-input v-model="menu.url" placeholder="输入链接" :disabled="disableUrl"></el-input>
                </el-form-item>
                <el-form-item label="序号" prop="orderd">
                    <el-input-number v-model="menu.orderd" :max="100" :min="1"></el-input-number>
                </el-form-item>
                <el-form-item label="父级菜单" prop="parentid">
                    <el-select v-model="menu.parentid" placeholder="请选择" style="width:100%;">
                        <el-option
                            v-for="item in menuList"
                            :value="item.id"
                            :key="item.id"
                            :label="item.name"
                        >{{ item.name }}</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="status" v-show="isAdd">
                    <el-select v-model="menu.status" placeholder="请选择" style="width:100%;">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" style="width:72px" type="info" @click="close('Cancel')">取消</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="addMenu('menu')"
                v-show="isAdd"
            >添加</el-button>
            <el-button
                size="mini"
                style="width:72px"
                type="primary"
                @click="updateMenu('menu')"
                v-show="isUpdate"
            >修改</el-button>
        </span>
    </el-dialog>
    <!-- 添加用户 Dialog: Begin -->
</template>

<script>
export default {
    components: {},
    props: ['addTitle'],
    data () {
        return {
            menu: {
                name: '',
                icon: '',
                url: '',
                orderd: 1,
                parentid: '',
                status: ''
            },
            disableUrl: true,
            dialogVisible: false,
            radio: '1',
            iconRadio: '',
            exist: 'have',
            menuList: [],
            isAdd: true,
            isUpdate: false,
            rules: {
                name: [
                    {
                        required: true,
                        message: '名称不能为空.',
                        trigger: 'blur'
                    },
                    { type: 'string', max: 16, message: '名称最大16个字符.' }
                ],
                icon: [
                    {
                        required: true,
                        message: '图标不能为空.',
                        trigger: 'change'
                    }
                ],
                url: [
                    {
                        type: 'string',
                        max: 32,
                        message: '链接最大32个字符.',
                        trigger: 'blur'
                    }
                ],
                orderd: [
                    {
                        required: true,
                        message: '序号不能为空.',
                        trigger: 'change'
                    }
                ],
                parentid: [
                    {
                        required: true,
                        message: '父级菜单不能为空.',
                        trigger: 'change'
                    }
                ],
                status: [
                    {
                        required: true,
                        message: '状态不能为空.',
                        trigger: 'change'
                    }
                ]
            }
        };
    },
    mounted () {},
    watch: {
        // 监听有无子菜单
        exist (value, oldValue) {
            if (value === 'have') {
                this.disableUrl = true;
                this.menu.url = '';
            } else {
                this.disableUrl = false;
            }
        }
    },
    methods: {
        /**
         * @author: liuc
         * @description:关闭弹窗
         * @param {operateType} 分页参数
         */
        close (operateType) {
            this.dialogVisible = false;
            this.menu = {
                id: '',
                name: '',
                icon: '',
                url: '',
                orderd: '',
                parentid: '',
                status: '',
                createdate: ''
            };
            this.exist = 'have';
            this.$refs.menu.resetFields(); // 移除校验结果
            this.$emit('closeAddModal', operateType); // 刷新表格
        },
        /**
         * @author: liuc
         * @description:打开弹窗，判断是“新增”还是“编辑”
         * @param {type} 弹窗类型
         * @param {id} id
         */
        async open (type, id) {
            // 编辑弹窗
            if (type == 1) {
                this.queryMenuById(id);
                this.isAdd = false;
                this.isUpdate = true;
            } else {
                // 新增弹窗
                this.isAdd = true;
                this.isUpdate = false;
            }
            this.dialogVisible = true;
        },
        /**
         * @author: liuc
         * @description: 获取菜单列表
         * @param {}
         */
        async queryMenuList () {
            let response = await this.$api.MenuManagement.getAll();
            this.menuList = response.data;
        },
        /**
         * @author: liuc
         * @description:根据id查询菜单信息
         * @param {id} 菜单id
         */
        async queryMenuById (id) {
            let response = await this.$api.MenuManagement.queryMenuById({
                id: id
            });
            this.menu = response.data;
            if (this.isNotNull(this.menu.url)) {
                this.exist = 'not';
            } else {
                this.exist = 'have';
            }
        },
        /**
         * @author: liuc
         * @description:新增菜单
         * @param {formName} 表单名称
         */
        addMenu (formName) {
            this.$refs[formName].validate(async (valid, notValid) => {
                if (valid) {
                    let result = await this.verifyName(this.menu.name);
                    if (result) {
                        let response = await this.$api.MenuManagement.addMenu(
                            this.menu
                        );
                        if (response.code == 200) {
                            this.$message.success('保存成功');
                            this.close('success');
                        }
                    }
                } else {
                    this.$message.error('验证失败');
                    return false;
                }
            });
        },
        /**
         * @author: liuc
         * @description:编辑菜单
         * @param {formName} 表单名称
         */
        updateMenu (formName) {
            this.$refs[formName].validate(async (valid, notValid) => {
                if (valid) {
                    let result = await this.verifyName(this.menu.name);
                    if (result) {
                        let response = await this.$api.MenuManagement.updateMenuById(
                            this.menu
                        );
                        if (response.code == 200) {
                            this.$message.success('修改成功');
                            this.close('success');
                        }
                    }
                } else {
                    this.$message.error('验证失败');
                    return false;
                }
            });
        },
        /**
         * @author: liuc
         * @description: 查询name是否重复
         * @param {name} 信息
         */
        async verifyName (name) {
            if (this.isNotNull(name)) {
                let nameData = {
                    name: name,
                    id: this.menu.id == undefined ? '' : this.menu.id
                };
                let response = await this.$api.MenuManagement.menuVerifyName(
                    nameData
                );
                if (response.data) {
                    return true;
                } else {
                    this.$message.error('菜单名称重复，请检查。');
                }
            }
            return false;
        },
        /**
         * @author: liuc
         * @description: 判断传入的值是否为空
         * @param {target} 传入内容
         */
        isNotNull (target) {
            if (target) {
                return true;
            } else {
                return false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#MenuAdd {
    /deep/ .el-dialog__body {
        padding: 30px 20px;
    }
    .menu-icon {
        font-size: 22px;
    }
    .menu-icon {
        .el-radio__label {
            font-size: 14px;
            padding-left: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/MenuManagement/Add.vue